import React, {useState} from "react";
import { Link } from 'react-router-dom';
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye';
import { useNavigate } from 'react-router-dom';

import LogoJFZ_signatureWhite from "../../../assets/jfz-white-transparent.png";
import LogoWholeheardedGlobalTransparent from "../../../assets/logo-wholehearted-global-transparent.png";
import HtmlTagName from "../../../utils/stringLiterals/HtmlTagName";
import UserManager from "../../../businessLayer/managers/UserManager";
import JsTypeInspector from "../../../serviceLayer/validators/JsTypeInspector";
import ProcessStatus from "../../../utils/enumerations/ProcessStatus";
import ValidationService from "../../../serviceLayer/validators/ValidationService";
import HttpStatusCode from "../../../utils/httpProtocol/HttpStatusCode";
import HtmlElementFormatter from "../../../utils/formatters/HtmlElementFormatter";

export default function Registration(){
    const _twoSecondsInMilliseconds = 2000;
    const _threeSecondsInMilliseconds = 3000;
    const navigate = useNavigate();
    const[usernameErrors, setUsernameErrors] = useState(""); 
    const[emailErrors, setEmailErrors] = useState("");
    const[passwordErrors, setPasswordErrors] = useState("");
    const[notification, setNotification] = useState(""); 
    const [type, setType] = useState(HtmlTagName.PASSWORD);
    const [icon, setIcon] = useState(eyeOff);


    function onButtonClickEvent(e){
        setUsernameErrors("");
        setEmailErrors("");
        setPasswordErrors("");
        setNotification("");
        //console.log("onButtonClickEvent-event: ", e);
        e.preventDefault();
        const report = UserManager.createUser(createUserPageCallback);
        //console.log("grantAccess-report", report);
        const reportIsValid = JsTypeInspector.objectIsValid(report); 
        if(reportIsValid && report.status === ProcessStatus.FailedWithErrors){
            processUsernameErrors(report);
            processEmailErrors(report);
            processPasswordErrors(report);
        }
    }
    

    function onInputChangeEvent(event){
        event.preventDefault();
        //console.log("onInputChangeEvent-event", event);
        clearInputs(event.target.name);
    }

    function onBlurEvent(){
        event.preventDefault();
        //console.log("onBlurEvent-event", event);
        clearInputs(event.target.name);
    }

    function togglePasswordVisibility(){
        //console.log("togglePasswordVisibility-triggered")
         //console.log("togglePasswordVisibility-type", type)
        if (type===HtmlTagName.PASSWORD){
            setIcon(eye);
            setType(HtmlTagName.TEXT )
        } else {
            setIcon(eyeOff)
            setType(HtmlTagName.PASSWORD )
        }
    }

    function updateFontColor(selectedClassName){
        const targetHtmlElementID = "registration-notification-message1";
        const classesToBeRemoved = ["font-color-red", "font-color-white", "font-color-darkblue"];
        const classesToBeAdded = [selectedClassName];

        HtmlElementFormatter.updateClassInHtmlElement(targetHtmlElementID, classesToBeRemoved, classesToBeAdded);
    }

    //#region Private Functions BEGIN
    function clearInputs(inputName){

        if(inputName === HtmlTagName.USERNAME){
            setUsernameErrors("");
        }
        if(inputName === HtmlTagName.EMAIL){
            setEmailErrors("");
        }
        if(inputName === HtmlTagName.PASSWORD){
            setPasswordErrors("");
        }
        setNotification("");
    }

    function processUsernameErrors(reportObj){
        const report = ValidationService.processErrors(reportObj, HtmlTagName.USERNAME);
        setUsernameErrors(report); 
    }

    function processEmailErrors(reportObj){
        const report = ValidationService.processErrors(reportObj, HtmlTagName.EMAIL);
        setEmailErrors(report); 
    }

    function processPasswordErrors(reportObj){
        const report = ValidationService.processErrors(reportObj, HtmlTagName.PASSWORD);
        setPasswordErrors(report);
    }

    function createUserPageCallback(httpResponse){
        //console.log("createUserPageCallback-httpResponse", httpResponse);
        if(httpResponse.code === HttpStatusCode._200ok.code ){
            updateFontColor("font-color-white");
            setNotification(httpResponse.payload.message); 
            
            setTimeout(()=>{
                //console.log("setTimeout-triggered: ", true);
                navigate("/public/login" , { state: { fromPage: location.pathname } });
            }, _twoSecondsInMilliseconds);
        }

        if(httpResponse.code === HttpStatusCode._400badRequest.code){
            setNotification(httpResponse.payload.message);
            updateFontColor("font-color-red");
        }

        if(httpResponse.code === HttpStatusCode._401unauthorized.code){
            setNotification(httpResponse.payload.message);
            updateFontColor("font-color-red");
        }

        if(httpResponse.code === HttpStatusCode._403forbidden.code){
            setNotification(httpResponse.payload.message);
            updateFontColor("font-color-red");
        }
        
        if(httpResponse.code === HttpStatusCode._409conflict.code){
            updateFontColor("font-color-red");
            setNotification(httpResponse.payload.message);            
            setUsernameErrors(httpResponse.payload.usernameConflict.message);
            setEmailErrors(httpResponse.payload.emailConflict.message);
        }
        
        if(httpResponse.code === HttpStatusCode._500InternalServerError.code){
            setNotification(httpResponse.payload.message);
            updateFontColor("font-color-red");
        }
    }

    //#region Private Functions END

    return(
    <div className="app-container">
            <div className="header registration-header-section">Registration</div>
            <div className="nav-bar-container-flex"></div>
            <div className="logo">                  
                <img src={LogoWholeheardedGlobalTransparent}  alt="logo_wholehearted_global" className="logo-wholehearted-public"/>
            </div>
            <span id="registration-notification-message1" className="notification-message" name={HtmlTagName.REGISTRATION} dangerouslySetInnerHTML={{ __html: notification }}></span>
             <form id="registrationCustomerForm1" className="form-flex">
                <input id="username1" 
                        type={HtmlTagName.USERNAME} 
                        name={HtmlTagName.USERNAME} 
                        onChange={onInputChangeEvent} 
                        onBlur={onBlurEvent}
                        placeholder="Username" 
                        className="input-field input-h45"
                />
                <span className="error-message" dangerouslySetInnerHTML={{ __html: usernameErrors }}></span>
                <input id="email1" 
                        type={HtmlTagName.EMAIL} 
                        name={HtmlTagName.EMAIL} 
                        onChange={onInputChangeEvent} 
                        onBlur={onBlurEvent}
                        placeholder="Email" 
                        className="input-field input-h45"
                />               
                <span className="error-message" dangerouslySetInnerHTML={{ __html: emailErrors }}></span>
                <div className="password-container">
                    <input id="password1" 
                            type={type}
                            name={HtmlTagName.PASSWORD}
                            onChange={onInputChangeEvent} 
                            onBlur={onBlurEvent}
                            placeholder="Password" 
                            className="input-field input-h45 password-field"
                    />
                    <span className="toggle-icon" onClick={togglePasswordVisibility}>
                        <Icon className="mr-10" icon={icon} size={25}/>
                    </span>
                </div>                
                <span className="error-message" dangerouslySetInnerHTML={{ __html: passwordErrors }}></span>
                <button type="button" className="btn-element login-btn" onClick={(e)=>{onButtonClickEvent(e);}}>Register</button>
            </form>
            <span className="position-rel basic-message-white left--5perc"> Already have an account?</span>
            <Link to="/public/login" className="position-rel basic-message-lightorange left-5perc">Sign In</Link>

            <div className="bottom flex-column-items-center">               
                <div className="signature-logo">                  
                    <img src={LogoJFZ_signatureWhite}  alt="logo_jfz_signature" className=""/>
                </div>
            </div>
    </div>);
}